module.exports = __webpack_public_path__ + "img/4.8735b2d9.jpg";